import { useEffect, useState } from 'react'
import { useHistory } from 'react-router-dom'

const usePathname = () => {
  const history = useHistory()
  const [pathname, setPathname] = useState(history.location.pathname)

  useEffect(() => {
    setPathname(history.location.pathname)

    return history.listen((location) => {
      setPathname(location.pathname)
    })
  }, [history])

  return pathname
}

export default usePathname
